<template>
  <div v-if="treeData.length > 0" class="list-group list-group-labels">
    <!-- :render-content="renderContent" -->
    <el-tree
      v-if="showExpanded"
      ref="tree"
      icon-class="el-icon-arrow-right"
      highlight-current
      node-key="id"
      :data="filterTreeData"
      :default-expanded-keys="expandTreeNode"
      :current-node-key="currentNodekey"
      :props="defaultProps"
      @node-click="handleNodeClick"
      @current-change="handleNodeChange"
    >
      <template v-slot="{ node, data }" class="custom-tree-node">
        <div
          draggable="true"
          @drop="fileDrop($event, data)"
          @dragstart.stop="dragStart($event, data)"
          @dragenter="dragenter"
          @dragover="dragover"
          @dragleave="dragleave"
          @dragover.prevent
        >
          <div v-if="data.className === 'el-owner'" class="el-tree-owner-node">
            <span>{{ node.label }}</span>
          </div>
          <div v-else-if="data.className === 'el-vault'" class="el-tree-vault-node d-flex align-items-center">
            <span class="iconfont icon-vault-sr icon-24 icon" />
            <span>{{ node.label }}</span>
          </div>
          <div v-else class="el-tree-folder-node">
            <FolderIcon class="icon" />
            <span>{{ node.label }}</span>
          </div>
        </div>
      </template>
    </el-tree>
    <el-tree
      v-else
      ref="move-tree"
      icon-class="el-icon-arrow-right"
      highlight-current
      node-key="id"
      :data="moveModalTreeData"
      :current-node-key="currentNodekey"
      :props="defaultProps"
      @node-click="handleMoveItem"
      @current-change="handleNodeChange"
    >
      <template v-slot="{ node, data }" class="custom-tree-node">
        <div>
          <div v-if="data.className === 'el-owner'" class="el-tree-owner-node">
            <span>{{ node.label }}</span>
          </div>
          <div
            v-else-if="data.className === 'el-vault'"
            class="el-tree-vault-node d-flex align-items-center"
            :class="data._canEdit === false ? 'disabled' : ''"
          >
            <span class="iconfont icon-vault-sr icon-24 icon" />
            <span>{{ node.label }}</span>
          </div>
          <div v-else class="el-tree-folder-node" :class="data._canEdit === false ? 'disabled' : ''">
            <FolderIcon class="icon" />
            <!-- <i class="el-icon-folder icon-24 icon" /> -->
            <span>{{ node.label }}</span>
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import { FolderIcon } from 'vue-feather-icons'
import { Tree, Notification } from 'element-ui'
Vue.use(Tree)

export default {
  name: 'ContentTree',
  components: {
    FolderIcon
  },
  props: {
    showExpanded: {
      type: Boolean,
      default: true
    },
    isOwn: {
      type: Boolean,
      default: true
    },
    // This is used for disabling all nodes where the user does not have CONTROL access to.
    controlPermissionOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      currentNodekey: ''
    }
  },
  computed: {
    ...mapState('contentTree', ['treeData', 'expandTreeNode']),
    ...mapState('moveModal', ['moveModalTreeData', 'moveModalExpandTreeNode']),
    ...mapState('home', ['selectedEntities']),
    filterTreeData() {
      if (this.treeData.length === 0) return []
      if (this.isOwn) {
        return this.treeData.filter((item, index) => index < 1)[0].children
      } else {
        return this.treeData.filter((item, index) => index >= 1)
      }
    }
  },

  watch: {
    expandTreeNode(newVal, oldVal) {
      this.currentNodekey = newVal[0]
      this.$refs.tree.setCurrentKey(this.currentNodekey)
    }
  },
  async created() {
    if (this.$route.params.folderId) {
      // child route loaded so lets load all vaults
      this.$store.dispatch('contentTree/getVaults', { self: this })
    }
  },
  methods: {
    dragStart(e, data) {
      if (data.className && data.className === 'el-vault') {
        e.currentTarget.parentElement.classList.remove('drag-active')
        return
      } else {
        const _data = JSON.stringify(data)
        e.dataTransfer.setData('tree-folder', _data)
      }
    },
    dragenter(e) {
      e.currentTarget.parentElement.classList.add('drag-active')
    },
    dragover(e) {
      e.preventDefault()
      e.currentTarget.parentElement.classList.add('drag-active')
    },
    fileDrop(e, data) {
      e.currentTarget.parentElement.classList.remove('drag-active')

      if (data.className.includes('el-owner')) {
        // Ignore trying to drop onto a user
        return
      }

      const tagetFileType = data.className.includes('el-folder') ? 'folder' : 'vault'
      const filetType = e.dataTransfer.types.includes('folder') ? 'folder' : 'doc'
      // check tree folder drag
      const isTreeFolder = e.dataTransfer.types.includes('tree-folder')
      if (isTreeFolder) {
        const folder = JSON.parse(e.dataTransfer.getData('tree-folder'))
        const entities = [
          {
            entityId: folder._id,
            entityType: 'Folder'
          }
        ]
        const destination = {
          entityId: tagetFileType === 'folder' ? data._id : data.vaultId,
          entityType: tagetFileType === 'folder' ? 'Folder' : 'Vault'
        }
        this.$store.dispatch('home/dragFilesMoveSuccess', { entities, destination })
      } else {
        if (tagetFileType === 'folder') {
          const targetFolderId = data._id
          if (filetType === 'doc') {
            const doc = JSON.parse(e.dataTransfer.getData('doc'))
            if (targetFolderId === doc.parentId) return

            const hasItem = this.selectedEntities.some(ele => ele._id === doc._id)
            !hasItem && this.$store.commit('home/PUSH_FILE_TO_SELECT_ENTITIES', doc)
            // this.$store.dispatch('home/dragDocToTreeFolderSuccess', {
            //   self: this,
            //   targetFolderId: targetFolderId,
            //   documentId: doc.id
            // })
          } else {
            const folder = JSON.parse(e.dataTransfer.getData('folder'))
            const includesFile = this.selectedEntities.some(item => item._id === targetFolderId)
            if (targetFolderId === folder._id || targetFolderId === folder.parentId || includesFile) return

            // const folder = JSON.parse(e.dataTransfer.getData('folder'))
            const hasItem = this.selectedEntities.some(ele => ele._id === folder._id)
            !hasItem && this.$store.commit('home/PUSH_FILE_TO_SELECT_ENTITIES', folder)
            // this.$store.dispatch('home/dragFolderToTreeFolderSuccess', {
            //   self: this,
            //   folderId: folder._id,
            //   targetFolderId: targetFolderId
            // })
          }
          const entities = this.selectedEntities.map(ele => {
            if (ele.fileType === 'folder') {
              return {
                entityId: ele._id,
                entityType: 'Folder'
              }
            } else {
              return {
                entityId: ele._id,
                entityType: 'Document'
              }
            }
          })
          const destination = {
            entityId: targetFolderId,
            entityType: 'Folder'
          }
          if (entities.some(item => item.entityId === data._id)) return
          this.$store.dispatch('home/dragFilesMoveSuccess', { entities, destination })
        } else {
          const targetVaultId = data.vaultId
          if (filetType === 'doc') {
            const doc = JSON.parse(e.dataTransfer.getData('doc'))
            if (doc.vaultId === targetVaultId && doc.parentId === '') return
            const hasItem = this.selectedEntities.some(ele => ele._id === doc._id)
            !hasItem && this.$store.commit('home/PUSH_FILE_TO_SELECT_ENTITIES', doc)

            // this.$store.dispatch('home/dragDocToTreeVaultSuccess', {
            //   self: this,
            //   documentId: doc.id,
            //   targetVaultId: targetVaultId
            // })
          } else {
            const _data = e.dataTransfer.getData('folder')
            const _folder = JSON.parse(_data)
            // if (folder.vaultId === targetVaultId && folder.parentId === '') return
            const hasItem = this.selectedEntities.some(ele => ele._id === _folder._id)
            !hasItem && this.$store.commit('home/PUSH_FILE_TO_SELECT_ENTITIES', _folder)
            // this.$store.dispatch('home/dragFolderToTreeVaultSuccess', {
            //   self: this,
            //   folderId: folder._id,
            //   targetVaultId: targetVaultId
            // })
          }
          const entities = this.selectedEntities.map(ele => {
            if (ele.fileType === 'folder') {
              return {
                entityId: ele._id,
                entityType: 'Folder'
              }
            } else {
              return {
                entityId: ele._id,
                entityType: 'Document'
              }
            }
          })
          const destination = {
            entityId: targetVaultId,
            entityType: 'Vault'
          }
          if (entities.some(item => item.entityId === data._id)) return
          this.$store.dispatch('home/dragFilesMoveSuccess', { entities, destination })
        }
      }
    },
    dragleave(e) {
      e.currentTarget.parentElement.classList.remove('drag-active')
    },
    handleNodeClick(data) {
      this.$store.dispatch('rightMenu/close')
      if (data.className.includes('el-owner')) {
        // Ignore trying to drop onto a user
        return
      } else if (data.vaultId === data._id) {
        this.$store.dispatch('appBreadcrumb/setBreadcrumb', data)
        this.$router.push('/vaults/' + data._id + '/0').catch(_ => {})
        this.$store.dispatch('home/getVaultIsEditable', { self: this, vaultId: data.vaultId })
      } else {
        this.$store.dispatch('appBreadcrumb/setBreadcrumb', data)
        this.$router.push('/vaults/' + data.vaultId + '/' + data._id).catch(_ => {})
        this.$store.dispatch('home/getVaultIsEditable', { self: this, vaultId: data.vaultId, folderId: data._id })
      }
    },
    handleMoveItem(data) {
      if (data._canEdit === false) {
        Notification.info('User does not have permission to edit this folder')
        return
      }

      let destination
      if (data.className === 'el-folder') {
        const targetFolderId = data._id || data.id
        this.$store.dispatch('moveModal/getFolderContents', {
          self: this,
          vaultId: this.$route.params.vaultId,
          folderId: targetFolderId,
          loadFolders: true
        })

        destination = {
          entityId: targetFolderId,
          entityType: 'Folder'
        }
      } else if (data.className === 'el-vault') {
        const targetVaultId = data.vaultId
        this.$store.dispatch('moveModal/getFolderContents', {
          self: this,
          vaultId: targetVaultId,
          folderId: '0',
          loadFolders: true
        })

        destination = {
          entityId: targetVaultId,
          entityType: 'Vault'
        }
      }

      this.$store.dispatch('moveModal/setDestination', { destination })
    },
    onClickNode(node) {
      this.labelModel = node[this.props.label]
      this.valueModel = node[this.props.value]
      this.onCloseTree()
    },
    handleNodeChange(data, node) {
      node.expand()
    }
  }
  // async moveEntity() {
  //   try {
  //     this.selectedEntities.forEach(async entity => {
  //       if (entity.extension) {
  //         // document
  //         await this.moveDocument(entity)
  //       } else {
  //         // folder
  //         await this.moveFolder(entity)
  //       }
  //     })
  //   } catch (err) {
  //   }
  // }
  // async moveDocument(doc) {
  //   await this.$store.dispatch('moveModal/dragFilesMoveSuccess', {
  //     self: this,
  //     vaultId: doc.vaultId,
  //     documentId: doc._id
  //   })
  //   await this.$store.dispatch('home/dragFilesMoveSuccess', {
  //     self: this,
  //     vaultId: doc.vaultId,
  //     documentId: doc._id
  //   })
  // },
  // async moveFolder(folder) {
  //   await this.$store.dispatch('moveModal/dragFilesMoveSuccess', {
  //     self: this,
  //     vaultId: folder.vaultId,
  //     folderId: folder._id
  //   })

  //   this.$store.dispatch('home/dragFilesMoveSuccess', {
  //     self: this,
  //     vaultId: folder.vaultId,
  //     folderId: folder._id
  //   })
  // }
}
</script>

<style lang="scss">
@import '../assets/scss/variables/_variables';
.el-tree-node__content {
  border: 2px dashed transparent;
  transition: 150ms all ease !important;
}
.el-tree-node__content > .el-tree-node__expand-icon {
  color: $txt-gray;
  font-weight: 800;
  font-size: 16px;
  font-style: normal;
  line-height: 26px;
  vertical-align: baseline;
  display: inline-block;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: var(--primary);
  font-weight: bold;
}
.el-tree-node {
  cursor: pointer;
  margin: 7px 0;
}
.el-tree {
  margin-left: 10px;
}

.drag-active {
  border-radius: 8px;
  border: 2px dashed var(--primary);
}
.icon {
  margin-right: 10px;
  color: var(--primary);
}

.is-focused {
  color: var(--primary);
}

.dark-layout .is-focused {
  color: $dark-layout-purple;
}
.dark-layout {
  .el-tree {
    color: $dark-layout-tree-color;
    background-color: $dark-layout-tree-bg;
    .el-tree-node__content {
      background-color: $dark-layout-tree-bg;
      transition: 150ms all ease !important;
    }
    .el-tree-node__content:hover {
      background-color: $dark-layout-tree-bg;
    }
    .el-tree-node__content > .el-tree-node__expand-icon {
      color: $dark-layout-tree-color;
    }
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: $dark-layout-tree-bg;
    }
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: $dark-layout-tree-bg !important;
  }

  .icon {
    margin-right: 10px;
    color: $dark-layout-tree-color;
  }
  .el-tree--highlight-current .el-tree-node.is-current {
    .icon {
      color: var(--primary);
    }
  }
}

.el-tree-node__content:hover {
  background-color: transparent !important;
  color: var(--primary);
}

.list-group-labels {
  margin-top: 0rem !important;
}

.el-tree-owner-node {
  color: var(--primary);
  font-weight: 600;
}

.disabled {
  color: $disable;
  cursor: not-allowed;
}
</style>
